export const investigationPageLoadUfo = {
	experienceName: 'jsm.rca-investigation' as const,
	customDataPhases: {
		inProgress: { rcaInvestigationPhase: 'IN_PROGRESS' as const },
		completed: { rcaInvestigationPhase: 'COMPLETED' as const },
		noRootCauseFound: { rcaInvestigationPhase: 'NO_ROOT_CAUSE_FOUND' as const },
		terminated: { rcaInvestigationPhase: 'TERMINATED' as const },
	} as const,
} as const;
